import { render, staticRenderFns } from "./PersonalDevelopmentPlanGuidance.vue?vue&type=template&id=5c54996e&scoped=true&"
import script from "./PersonalDevelopmentPlanGuidance.vue?vue&type=script&lang=js&"
export * from "./PersonalDevelopmentPlanGuidance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c54996e",
  null
  
)

export default component.exports